import { FunctionComponent } from 'react'
import { registerType } from '../types'
import ClockSvg from '../ClockSvg/index'

interface SelectInterface {
  id: string
  name: string
  options: Array<string>
  errorMessage?: string
  show?: 'time' | 'empty' | 'null'
  label?: string
  defaultValue?: string
  register: Function
  registerOptions?: registerType
  short?: boolean
}

const Select: FunctionComponent<SelectInterface> = ({
  id,
  name,
  options,
  label,
  errorMessage,
  show = 'empty',
  register,
  registerOptions,
  short
}) => {
  const empty =
    show === 'empty' || show === 'time' ? <option label=""></option> : void 0
  const time = show === 'time' ? <ClockSvg /> : void 0
  return (
    <div
      className={`wc-form-item${
        short ? ' wc-form-item w-auto sm:w-5/12 md:w-6/12 lg:w-5/12' : ''
      }`}
    >
      {label && (
        <label htmlFor={id} className="label-primary">
          {label}
        </label>
      )}
      {errorMessage && (
        <span
          className="field-validation-error wc-assist wc-assist__bottom wc-assist--error"
          key={errorMessage}
          style={{ lineHeight: 0.5 }}
          role="alert"
        >
          {errorMessage}
        </span>
      )}
      <div className="wc-select wc-select--small flex items-center">
        {time && <label htmlFor={id}>{time}</label>}
        <select
          id={id}
          aria-label="select an option"
          {...register(name, registerOptions)}
        >
          {empty}
          {options.map((option) => (
            <option value={option} key={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}

export default Select
